// deno-lint-ignore-file ban-unused-ignore no-explicit-any no-empty-interface
///////////////////////////////////
// !!! DO NOT EDIT THIS FILE !!! //
///////////////////////////////////

import type { SlackAPIResponse } from "../response";
export type AdminUsersSessionGetSettingsResponse = SlackAPIResponse & {
  error?: string;
  needed?: string;
  no_settings_applied?: string[];
  ok: boolean;
  provided?: string;
  session_settings?: SessionSetting[];
};

export interface SessionSetting {
  desktop_app_browser_quit?: boolean;
  duration?: number;
  user_id?: string;
}
